/**
 * Пиксельная стопка карточек со звёздочкой — картинка «Задания дня» на главной, в стиле игры «Выживи в Лондоне»
 * (решение владельца 2026-10-23: «для миссии и задания — фото, иконки или ещё что-то»; выбран пиксель-арт игры).
 * Сетка 16×16, каждая клетка — квадрат 1×1; `crispEdges` держит пиксели чёткими при любом целом увеличении.
 */
const GRID = [
  '......oooooooo..',
  '......obbbbbbo..',
  '......obbbbbbo..',
  '..ooooooooobbo..',
  '..occcccccobbo..',
  '..occcccccobbo..',
  '..occcscccobbo..',
  '..occsSsccobbo..',
  '..occcscccobbo..',
  '..occcccccobbo..',
  '..oclllllcoooo..',
  '..occccccco.....',
  '..occllllco.....',
  '..occccccco.....',
  '..ooooooooo.....',
  '................',
];

const COLORS: Record<string, string> = {
  o: '#1b1a26',
  b: '#8c9bd1',
  c: '#f4ecd8',
  l: '#c9b98f',
  s: '#f2c14e',
  S: '#f36a1c',
};

export function PixelCardsIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 16 16" shapeRendering="crispEdges" className={className} aria-hidden>
      {GRID.flatMap((row, y) =>
        [...row].map((cell, x) =>
          COLORS[cell] ? <rect key={`${x}-${y}`} x={x} y={y} width={1} height={1} fill={COLORS[cell]} /> : null,
        ),
      )}
    </svg>
  );
}
